<style lang="scss" scoped>
.navbar {
    padding: 20px 60px;
    display: flex;
    flex-wrap: wrap;
    box-shadow: -6px 0 12px rgba(0, 0, 0, 0.06);
    .cushion {
        height: 50px;
        width: auto;
        margin-right: 30px;
    }
    .item {
        line-height: 24px;
        margin: auto 20px;
        &.active {
            font-weight: 700;
            color: var(--gold);
        }
    }
}
.mobile-navbar {
    height: 50px;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1001;
    box-shadow: 0px -1px 0px 0px var(--border-color);
    .mobile-nav-item {
        &:not(.active) {
            opacity: 0.5;
        }
    }
}
.notifications {
    background: #fff;
    position: absolute;
    width: 426px;
    box-shadow: -6px 0 12px rgba(0, 0, 0, 0.06);
    top: 40px;
    right: -213px;
    z-index: 100;
    border-radius: 2px;
    .view-all {
        border-top: 1px solid var(--border-color);
    }
    .nav-item {
        cursor: pointer;
        line-height: 24px;
        &:hover {
            background: var(--white-hover);
        }
    }
    .read-at {
        background: var(--gold);
        border-radius: 50%;
        width: 8px;
        height: 8px;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
    }
}
.nav-items {
    @media only screen and (max-width: 1023px) {
        position: fixed;
        height: calc(100vh - 50px);
        height: calc(var(--vh, 1vh) * 100 - 50px);
        z-index: 100;
        background-image: linear-gradient(
            180deg,
            var(--primary) 0%,
            var(--primary-dark) 100%
        );
        bottom: 50px;
        right: -100vw;
        top: 0;
        display: flex;
        flex-flow: column;
        width: 100%;
        text-align: center;
        padding: 0 60px;
        overflow: hidden;
        transition: right 0.3s;
        .item {
            color: #fff;
            text-align: center;
            margin: 23px auto;
            &.active {
                font-weight: 700;
            }
        }
        &.open {
            right: 0;
        }
    }
    @media only screen and (min-width: 992px) {
        margin: auto;
    }
}
.new-notification {
    width: 10px;
    height: 10px;
    background-color: var(--danger);
    border: 2px solid #fff;
    display: block;
    position: absolute;
    right: -3px;
    border-radius: 50%;
}
.mobile-new-notification {
    right: 24px;
    top: 0;
}
.mobile-footer {
    display: flex;
    flex-flow: row;
    .mobile-footer-item {
        width: 25%;
    }
}
</style>

<template>
    <div v-if="$root.sizer === 'lg'" class="navbar">

        <router-link :to="{ name: 'sleep-schedule'}" active-class="active">
            <img class="cushion" src="/images/cushion.png" alt="Start to sleep">
        </router-link>

        <router-link :to="{ name: 'sleep-schedule'}" class="item" active-class="active">
            {{ $t('navbar.sleepschedule') }}
        </router-link>

        <router-link :to="{ name: 'tips' }" class="item mr-auto" active-class="active">
            {{ $t('navbar.tips') }}
        </router-link>

        <div class="item d-flex">
            <i-back class="i-14 mr-8 fill-primary-dark my-auto c-pointer" @click="prevWeek" :class="{ 'fill-gray': this.currentWeek === 1 }"></i-back>
            <i-back class="i-14 mr-16 fill-primary-dark my-auto c-pointer" @click="nextWeek" style="transform: rotate(180deg)" :class="{ 'fill-gray': this.currentUser.user.total_weeks === this.currentWeek}"></i-back>
            <span class="small text-primary-dark us-none">{{ $t('navbar.week_x', {week: currentWeek}) }}</span>
        </div>

        <!-- <div class="item d-flex position-relative" v-click-outside="() => { showNotifications = false  }">
            <i-bell class="i-20 m-auto c-pointer" @click.stop="showNotifications = !showNotifications"></i-bell>
            <div class="new-notification" v-if="newNotification"></div>
            <div v-if="showNotifications" class="notifications py-16">
                <div class="group">
                    <p class="fw-b mb-16 mt-16 px-24 d-flex">
                        <span class="h4 fw-b my-auto">{{ $t('navbar.notifications') }}</span>
                        <a hef="#" @click.prevent="readAllNotifications" class="text-right text-gold small px-16 c-pointer ml-auto my-auto">{{ $t('notifications.mark_all_as_read') }}</a>
                    </p>
                    <template v-if="notifications.length > 0">
                        <div class="nav-item" v-for="notification in notifications" :key="notification.id">
                            <a @click.prevent="goToNotificationRoute(notification)" class="pr-16 py-8 border-bottom d-block position-relative mx-24 my-auto">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <p class="text-dark">{{ $t(`navbar.${notification.message}`) }}</p>
                                        <p class="small text-gray">{{ [ notification.created_at ] | moment("from", "now") }}</p>
                                        <span v-if="notification.read_at === null" class="read-at"></span>
                                    </div>
                                    <div v-if="$t(`navbar.${notification.message}_cta`) !== `navbar.${notification.message}_cta`" class="flex-shrink-0">
                                        <button class="ml-16 btn btn-outline-primary-dark">{{ $t(`navbar.${notification.message}_cta`) }}</button>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </template>
                    <div v-else class="nav-item py-8 text-gray text-center">
                        {{ $t('notifications.no_notifications') }}
                    </div>
                </div>
                <div class="view-all text-center pt-16">
                    <router-link :to="{ name: 'notifications'}" class="small fw-b">{{ $t('notifications.view_all') }}</router-link>
                </div>
            </div>
        </div> -->

        <div class="item d-none">
            <i-hat class="i-20 m-auto"></i-hat>
        </div>
    </div>
    <div v-else-if="($root.sizer === 'sm' || $root.sizer === 'md')" class="mobile-navbar container-fluid">

        <div class="nav-items pt-32" :class="{ open: mobileNavOpen}">
            <router-link :to="{ name: 'user-settings' }" class="item" active-class="active">
                {{ $t('sidebar.user-settings') }}
            </router-link>
            <router-link :to="{ name: 'user-habits' }" class="item" active-class="active">
                {{ $t('sidebar.user-habits') }}
            </router-link>
            <router-link :to="{ name: 'user-medical' }" class="item" active-class="active">
                {{ $t('sidebar.user-medical') }}
            </router-link>
            <router-link :to="{ name: 'user-license' }" class="item" active-class="active">
                {{ $t('sidebar.user-license') }}
            </router-link>
            <router-link :to="{ name: 'user-password' }" class="item" active-class="active">
                {{ $t('sidebar.user-password') }}
            </router-link>
            <router-link :to="{ name: 'logout' }" class="btn btn-outline-white mx-auto mt-48" active-class="active">
                {{ $t('sidebar.sign-off') }}
            </router-link>
        </div>

        <div class="mobile-footer h-100">
            <div class="mobile-footer-item text-center my-auto" @click="mobileNavOpen = false">
                <router-link :to="{ name: 'sleep-schedule'}" class="item mobile-nav-item small d-flex flex-column text-primary-dark" exact-active-class="active">
                    <i-calendar class="i-17 mb-4"></i-calendar>
                    <span class="text-uppercase small">{{ $t('navbar.sleepschedule') }}</span>
                </router-link>
            </div>
            <div class="mobile-footer-item text-center my-auto" @click="mobileNavOpen = false">
                <router-link :to="{ name: 'user-schedule' }" class="item mobile-nav-item small d-flex flex-column text-primary-dark" active-class="active">
                    <i-wakeup class="i-20 mb-4"></i-wakeup>
                    <span v-if="currentUser.user.profession_type_id !== 2" class="text-uppercase small"> {{ $t('navbar.schedule') }} </span>
                    <span v-else class="text-uppercase small"> {{ $t('navbar.progress') }} </span>
                </router-link>
            </div>
            <div class="mobile-footer-item text-center my-auto" @click="mobileNavOpen = false">
                <router-link :to="{ name: 'tips' }" class="item mobile-nav-item small d-flex flex-column text-primary-dark" active-class="active">
                    <i-bulb class="i-17 mb-4"></i-bulb>
                    <span class="text-uppercase small"> {{ $t('navbar.tips') }} </span>
                </router-link>
            </div>
            <div class="mobile-footer-item text-center my-auto" @click="mobileNavOpen = false">
                <router-link :to="{ name: 'notifications' }" class="item mobile-nav-item small d-flex flex-column text-primary-dark" active-class="active">
                    <div class="position-relative">
                        <i-bell class="i-17 mb-4"></i-bell>
                        <div class="new-notification mobile-new-notification" v-if="notifications.filter((n) => n.read_at === null).length > 0"></div>
                    </div>
                    <span class="text-uppercase small"> {{ $t('navbar.notifications') }} </span>
                </router-link>
            </div>
            <div class="mobile-footer-item text-center my-auto">
                <a href="#" @click.prevent="mobileNavOpen = !mobileNavOpen" class="item mobile-nav-item small d-flex flex-column text-primary-dark" :class="{'active' : $route.path.startsWith('/user/')}">
                    <i-cog class="i-17 mb-4"></i-cog>
                    <span class="text-uppercase small"> {{ $t('navbar.settings') }} </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
    data() {
        return {
            showNotifications: false,
            mobileNavOpen: false,
        }
    },
    mounted() {
        this.$store.dispatch('user/readNotifications', this.currentUser.user.id).then(() => {
            this.showNotifications = this.newNotification
        })
    },
    methods: {
        nextWeek() {
            if (this.currentWeek < this.currentUser.user.total_weeks)
                this.$store.dispatch('schedule/incrementWeek')
        },
        prevWeek() {
            this.$store.dispatch('schedule/decrementWeek')
        },
        goToNotificationRoute(n) {
            let notification_status = [{ id: n.id, read: true }]
            this.$store.dispatch('user/updateNotifications', { user_id: this.currentUser.user.id, data: notification_status }).then(() => {
                let route = ''
                if (n.resource_type === 'tip') route = { name: 'tip-detail', params: { id: n.resource_id } }
                if (n.resource_type === 'diary_entry') route = { name: 'schedule-details', query: { date: n.metadata.date, week: n.resource_id } }
                if (n.resource_type === 'sleep_schedule') route = { name: 'user-habits' }
                if (n.resource_type === null) route = { name: 'notifications' }
                if (route !== '') this.$router.push(route)
            })
        },
        readAllNotifications() {
            let notification_status = this.notifications.map((n) => { return { id: n.id, read: true } })
            this.$store.dispatch('user/updateNotifications', { user_id: this.currentUser.user.id, data: notification_status })
        },
    },
    computed: {
        currentWeek() {
            return this.$store.getters['schedule/currentWeek']
        },
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
        notifications() {
            return this.$store.getters['user/notifications'].slice(0, 5)
        },
        newNotification() {
            return this.notifications.filter((n) => n.read_at === null).length > 0
        },
    },
    directives: {
        ClickOutside
    }
}
</script>
  